import {useQuery} from "react-query"
import useAuth from "auth/useAuth"

export default function useShiftRoster(area, week) {

    const {auth, API} = useAuth()

    const query = useQuery(
        ["shift-roster", area, week],
        () => auth(API.shiftsRosterAreaWeekGet, {area, week}).then(response => {
            const data = response.data
            if (data?.errorType) throw new Error(data.errorMessage || 'Lambda error')
            return data
        }),
        {enabled: !!area && !!week}
    )

    const roster = query.data?.roster
    const pending = query.data?.pending
    const permissions = query.data?.permissions || {edit: false}

    console.log('[ShiftRoster]', {
        area, week,
        status: query.status,
        isIdle: query.isIdle,
        isError: query.isError,
        error: query.error,
        isFetching: query.isFetching,
        dataType: typeof query.data,
        dataKeys: query.data != null ? Object.keys(query.data) : query.data,
    })

    return {...query, roster, pending, permissions}

}
